import { isRef, toValue, watch, type Ref } from "vue";
import type { ReadonlyRefOrGetter } from "@vueuse/core";

export function waitUntil(watchedValue: ReadonlyRefOrGetter<boolean>) {
  return new Promise<void>((resolve) => {
    const unwatch = watch(watchedValue, (value) => {
      if (value) {
        unwatch();
        resolve();
      }
    });
  });
}


export type UnwrappedRefRecord<T> = {
  [K in keyof T]: T[K] extends Ref<infer U> ? U : T[K];
};

export function unwrapRefs<T extends Record<string, Ref<unknown> | unknown>>(obj: T): UnwrappedRefRecord<T> {
  if (obj && typeof obj === 'object') {
    const unwrapped: Partial<UnwrappedRefRecord<T>> = {};
    for (const k in obj) {
      const key = k as keyof T;
      const value = obj[key];

      if (isRef(value)) {
        unwrapped[key] = toValue(value) as any;
        continue;
      }

      unwrapped[key] = value as any;
    }
    return unwrapped as UnwrappedRefRecord<T>;
  }
  return obj;
}
